@if (closebyItems() && closebyItems().length > 0 && isDataLoaded()) {
  <h2 class="text-2xl font-bold mb-2  text-white">Utforska fler vårdgivare</h2>
  <div class="text-base text-white mb-5">
    Utforska andra vårdgivare i närheten av {{ location() }}.
  </div>
  <aside>
    <div class="min-h-[28.5rem] -mx-4">
      <app-carousel
        [isPageWithSidebar]="isPageWithSidebar()"
        [pageType]="pageType()"
        [puffType]="'closeby-v2'"
        [puffs]="closebyItems()"
      ></app-carousel>
    </div>
  </aside>

  <div class="flex justify-center items-center p-5">
    <app-ui-button (onClick)="onClick($event)" [color]="'flat'" [size]="'md'">
      <app-ui-icon name="map"></app-ui-icon>
      Hitta fler vårdgivare
    </app-ui-button>
  </div>
}

